import React, { useEffect, useState } from "react";
import { FiX, FiSearch, FiPlus } from "react-icons/fi";
import { useTranslation } from 'react-i18next';

interface WorkspacePanelProps {
  onClose: () => void;
  onOpenProject?: (project: any) => void;
}

interface Project {
  id: number;
  name: string;
  date: string;
}

const WorkspacePanel: React.FC<WorkspacePanelProps> = ({ onClose, onOpenProject = () => {} }) => {
  const { t } = useTranslation('dashboard');
  const [projects, setProjects] = useState<Project[]>([]);

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("projects.saved") || "[]");
    setProjects(saved);
  }, []);

  return (
    <div className="absolute left-full top-0 w-80 h-full bg-white border-l border-gray-200 shadow-lg p-4 flex flex-col z-50">
      {/* ✅ En-tête */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold text-black">{t('workspacePanel.title')}</h2>
        <button onClick={onClose} className="text-gray-500 hover:text-red-500">
          <FiX size={20} />
        </button>
      </div>

      {/* 🔍 Recherche */}
      <div className="relative mb-3">
        <FiSearch className="absolute left-3 top-2.5 text-gray-400" />
        <input
          type="text"
          placeholder={t('workspacePanel.searchPlaceholder')}
          className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md text-sm"
        />
      </div>

      {/* 📁 Liste des projets sauvegardés */}
      <div className="flex-1 overflow-y-auto space-y-2">
        {projects.length === 0 ? (
          <p className="text-sm text-gray-500">{t('workspacePanel.noProjects')}</p>
        ) : (
          projects.map((proj) => (
            <div
              key={proj.id}
              className="p-2 border rounded-md hover:bg-gray-100 cursor-pointer"
              onClick={() => onOpenProject(proj)} // ✅ appel sécurisé (valeur par défaut)
            >
              <p className="font-medium text-black">{proj.name}</p>
              <p className="text-xs text-gray-500">
                {new Date(proj.date).toLocaleString()}
              </p>
            </div>
          ))
        )}
      </div>

      {/* ➕ Bouton nouveau workspace */}
      <button className="w-full flex items-center justify-center gap-2 bg-blue-700 hover:bg-blue-800 text-white text-sm py-2 rounded-md mt-4">
        <FiPlus />
        {t('workspacePanel.newWorkspace')}
      </button>
    </div>
  );
};

export default WorkspacePanel;
